export default function r(r, e) {
  const t = Array.isArray(e) ? e : [e]
  let a = r
  t.forEach((r) => {
    a = a.replace('%s', r)
  })
  return a
}
